import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const LockIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M12 3C13.9732 3 15.5714 4.67812 15.5714 6.75V9H8.42857V6.75C8.42857 4.67812 10.0268 3 12 3ZM5.57143 6.75V9H4.85714C3.28125 9 2 10.3453 2 12V21C2 22.6547 3.28125 24 4.85714 24H19.1429C20.7188 24 22 22.6547 22 21V12C22 10.3453 20.7188 9 19.1429 9H18.4286V6.75C18.4286 3.02344 15.5491 0 12 0C8.45089 0 5.57143 3.02344 5.57143 6.75ZM13.4286 15V18C13.4286 18.8297 12.7902 19.5 12 19.5C11.2098 19.5 10.5714 18.8297 10.5714 18V15C10.5714 14.1703 11.2098 13.5 12 13.5C12.7902 13.5 13.4286 14.1703 13.4286 15Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default LockIcon
